<template>
  <div class="xcard">
    <!-- <p class="text-righ" :title="atras" style="position:relative;top:0px;right:15px;margin-bottom:0"> <router-link :to="atras" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-arrow-left"></span> Volver</router-link> </p> -->
    <v-btn small class="" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <RegistroEstudiante />
    <p class="text-righ" :title="atras" style="position:relative;top:0px;right:15px;margin-bottom:0"> <router-link :to="atras" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-arrow-left"></span> Volver</router-link> </p>
  </div>
</template>

<script>
import RegistroEstudiante from '@/components/AModEstudiante.vue'
export default {
  data(){
    return{
      atras:'personas'
    }
  },
  components:{ RegistroEstudiante },
  mounted(){
    var atrs = window.sessionStorage.xxatrs;
    if( atrs ) this.atras = atrs;
  }
  
}
</script>